export const translation = {
  cupis: {
    ru: {
      siteTitle15: "Забери бонус до 15 000 RUB | БК ZENIT",
      siteTitle20: "Забери бонус до 20 000 RUB | БК ZENIT",
      rulesBtnText: "Правила",
      textSince: "Работаем с 1998 года",
      titleLine1: "",
      titleLine2: "Бонус",
      titleLine3: "до",
      titleLine4: "для яркого",
      titleLine5: "старта",
      btnGet: "Забрать",
      conditionSpan1: "Зарегистрируйся",
      conditionSpan1Extra: `
        и пройди`,
      conditionText1: "идентификацию",
      conditionSpan2: "Пополни",
      conditionText2: `
        счет`,
      conditionSpan3: "Забери 100%",
      conditionText3: `от суммы депозита
        бонусом`,
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-55-50",
    }
  }
}
